// Locale-aware CHF + date formatting helpers used across the admin UI.

export function chf(rappen: number, lang: string): string {
  return new Intl.NumberFormat(lang, { style: 'currency', currency: 'CHF' }).format(rappen / 100);
}

export function formatDateShort(ymd: string, lang: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Intl.DateTimeFormat(lang, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(y!, m! - 1, d!)));
}

export function formatDateLong(ymd: string, lang: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Intl.DateTimeFormat(lang, {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(y!, m! - 1, d!)));
}

export function chfToRappen(s: string): number {
  const cleaned = s.replace(',', '.').trim();
  if (!cleaned) return 0;
  const n = Number.parseFloat(cleaned);
  if (!Number.isFinite(n) || n < 0) return Number.NaN;
  return Math.round(n * 100);
}

export function rappenToChfString(rappen: number): string {
  const sign = rappen < 0 ? '-' : '';
  const abs = Math.abs(rappen);
  const whole = Math.floor(abs / 100);
  const cents = String(abs % 100).padStart(2, '0');
  return `${sign}${whole}.${cents}`;
}
